/**
 * Architecture object type constants
 * @module constants/object-types
 */

/** ArchiMate-inspired object types */
export const OBJECT_TYPES = [
  'Application',
  'Technology',
  'BusinessCapability',
  'Person',
  'Organization',
] as const;
export type ObjectType = (typeof OBJECT_TYPES)[number];

/** Object lifecycle statuses */
export const OBJECT_STATUSES = ['draft', 'active', 'deprecated', 'retired'] as const;
export type ObjectStatus = (typeof OBJECT_STATUSES)[number];

/** Lifecycle phases (TIME model) */
export const LIFECYCLE_PHASES = ['plan', 'build', 'run', 'retire'] as const;
export type LifecyclePhase = (typeof LIFECYCLE_PHASES)[number];

/** Application criticality levels */
export const CRITICALITY_LEVELS = ['critical', 'high', 'medium', 'low'] as const;
export type CriticalityLevel = (typeof CRITICALITY_LEVELS)[number];

/** Data classification levels */
export const DATA_CLASSIFICATIONS = ['public', 'internal', 'confidential', 'restricted'] as const;
export type DataClassification = (typeof DATA_CLASSIFICATIONS)[number];

/** Technical debt levels */
export const TECHNICAL_DEBT_LEVELS = ['low', 'medium', 'high'] as const;
export type TechnicalDebtLevel = (typeof TECHNICAL_DEBT_LEVELS)[number];

/** Hosting models */
export const HOSTING_MODELS = ['on-premise', 'iaas', 'paas', 'saas'] as const;
export type HostingModel = (typeof HOSTING_MODELS)[number];

/** Technology categories */
export const TECHNOLOGY_CATEGORIES = [
  'language',
  'framework',
  'database',
  'platform',
  'tool',
  'infrastructure',
] as const;
export type TechnologyCategory = (typeof TECHNOLOGY_CATEGORIES)[number];

/** Technology support levels */
export const SUPPORT_LEVELS = ['strategic', 'tactical', 'legacy', 'prohibited'] as const;
export type SupportLevel = (typeof SUPPORT_LEVELS)[number];

/** License types */
export const LICENSE_TYPES = ['open-source', 'commercial', 'freemium'] as const;
export type LicenseType = (typeof LICENSE_TYPES)[number];

/** Business capability levels */
export const CAPABILITY_LEVELS = [0, 1, 2] as const;
export type CapabilityLevel = (typeof CAPABILITY_LEVELS)[number];

/** Strategic importance levels */
export const STRATEGIC_IMPORTANCE = ['core', 'supporting', 'generic'] as const;
export type StrategicImportance = (typeof STRATEGIC_IMPORTANCE)[number];

/** Investment profiles */
export const INVESTMENT_PROFILES = ['invest', 'maintain', 'divest'] as const;
export type InvestmentProfile = (typeof INVESTMENT_PROFILES)[number];

/** Organization types */
export const ORGANIZATION_TYPES = ['company', 'department', 'team', 'vendor', 'partner'] as const;
export type OrganizationType = (typeof ORGANIZATION_TYPES)[number];
